import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'
import FileSaver from 'file-saver'

export const addDescription = ({ commit }, payload) => {
  try {
    axios({ url: ENTRYPOINT + '/api/description-espace/ajout', data: payload, method: 'POST' })
  } catch (err) {
    console.log('addDescription error:', err)
  }
}

export const modifyDescription = ({ commit }, payload) => {
  try {
    axios({ url: ENTRYPOINT + '/api/description-espace/modification', data: payload, method: 'POST' })
  } catch (err) {
    console.log('modifyDescription error:', err)
  }
}

export const getDescription = async ({ commit }, payload) => {
  try {
    const res = await axios({ url: ENTRYPOINT + '/api/description-espace/' + payload.onglet + '/' + payload.espace, method: 'GET' })
    return res
  } catch (err) {
    return false
  }
}

export const exportDescription = async ({ commit }, payload) => {
  try {
    const res = await axios({ url: ENTRYPOINT + '/api/description-espace-telecharger/' + payload.onglet, data: payload.data, method: 'POST', responseType: 'blob' })
    FileSaver.saveAs(res.data, 'espace.docx')
    return true
  } catch (err) {
    return false
  }
}

// mode invite

export const getInviteDescription = async ({ commit }, payload) => {
  try {
    const res = await axios({ url: ENTRYPOINT + '/invite/description-espace/' + payload.onglet + '/' + payload.espace, method: 'GET' })
    return res
  } catch (err) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/descriptionEspace/actions.js